import { makeStyles } from '@material-ui/core/styles';

export const useSettingStyles = makeStyles(() => ({
    snmpDialog: {
        width: 680,
        boxSizing: 'border-box',
    },
    severitySelection: {
        '& .MuiSelect-select': {
            minWidth: 500,
        },
    },
    snmpSelection: {
        '& .MuiSelect-select': {
            minWidth: 300,
        },
    },
    selectionError: {
        color: '#BF3D56',
    },
    mibField: {
        fontSize: '15px',
        padding: '15px 0 2px 2px',
        fontStyle: 'italic',
    },
}));
